import notificationIcon from '~/assets/icons/icon-notification.png'
import notificationSound from '~/assets/sounds/notification.mp3'
import Logger from '~/services/Logger'
import { isElectron } from '~/utils/common'
import { isDesktopBrowser } from '~/utils/deviceType'

const isSupported = () => 'Notification' in window

const logger = new Logger('notifications.ts')

export const canSendNotification = () => {
  if (!isSupported()) {
    return false
  }
  if (isElectron) {
    return true
  }
  return isDesktopBrowser()
}

interface SendNotificationParams {
  title: string
  body: string
  onClick?: () => void
  playSound?: boolean
}

const playNotificationSound = async () => {
  const sound = new Audio(notificationSound)

  try {
    await sound.play()
  } catch (error: unknown) {
    logger.debug(`Error playing notification sound: ${error}`)
  }
}

// The desktop app shows texts in the popup window, so it only plays the sound.
export const sendNotification = async ({
  title,
  body,
  onClick,
  playSound,
}: SendNotificationParams) => {
  if (isElectron) {
    if (playSound) await playNotificationSound()
    return
  }
  if (!canSendNotification()) return
  if (Notification.permission === 'granted') {
    try {
      const notification = new Notification(title, {
        body,
        icon: notificationIcon,
      })

      notification.onclick = () => {
        onClick?.()
        notification.close()
      }

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
          // The tab has become visible so clear the now-stale Notification.
          notification.close()
        }
      })

      if (playSound) await playNotificationSound()
    } catch (error: unknown) {
      // Handle cases where Notification constructor fails
      // (e.g., when a service worker is controlling the page)
      logger.debug(`Error creating notification: ${error}`)
      return
    }
  }
}
